import React from 'react';
import Icon from '../../../components/AppIcon';
import { getEventTypeStyle, getEstadoStyle } from './AdvancedFilters';

const RightPanel = ({ eventos, onEventClick }) => {
  const today = new Date()?.toISOString()?.split('T')?.[0];
  const now = new Date();
  const startOfWeek = new Date(now);
  startOfWeek?.setDate(now?.getDate() - now?.getDay() + 1);
  const endOfWeek = new Date(startOfWeek);
  endOfWeek?.setDate(startOfWeek?.getDate() + 6);
  const startOfWeekStr = startOfWeek?.toISOString()?.split('T')?.[0];
  const endOfWeekStr = endOfWeek?.toISOString()?.split('T')?.[0];

  const eventosHoy = eventos?.filter(e => e?.fecha === today) || [];
  const eventosSemana = eventos?.filter(e => e?.fecha >= startOfWeekStr && e?.fecha <= endOfWeekStr && e?.fecha !== today) || [];
  const pendientesConfirmar = eventos?.filter(e => e?.estado === 'PROGRAMADO' || e?.estado === 'Pendiente') || [];
  const urgentes = eventos?.filter(e => e?.tipoServicio === 'Urgente') || [];

  const EventItem = ({ ev }) => {
    const typeStyle = getEventTypeStyle(ev?.tipoServicio);
    const estadoStyle = getEstadoStyle(ev?.estado);
    return (
      <div onClick={() => onEventClick(ev)}
        className="p-2.5 rounded-lg bg-white/3 hover:bg-white/6 cursor-pointer transition-all duration-150 border border-white/5 hover:border-white/10 group">
        <div className="flex items-start gap-2">
          <div className="w-1 self-stretch rounded-full flex-shrink-0 mt-0.5" style={{ background: typeStyle?.color }} />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-oranienbaum font-semibold text-white/80 group-hover:text-white truncate">{ev?.cliente || 'Sin cliente'}</p>
            <p className="text-[10px] text-white/35 font-oranienbaum truncate">{ev?.fecha} {ev?.horaInicio ? `· ${ev?.horaInicio}` : ''}</p>
            <div className="flex items-center gap-1 mt-1">
              <span className="text-[9px] font-oranienbaum px-1.5 py-0.5 rounded-full" style={{ color: estadoStyle?.color, background: estadoStyle?.bg }}>
                {ev?.estado}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const Section = ({ title, icon, iconColor, events, emptyMsg }) => (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <Icon name={icon} size={13} style={{ color: iconColor }} />
        <span className="text-xs font-oranienbaum font-semibold text-white/60 uppercase tracking-wide">{title}</span>
        <span className="ml-auto text-xs font-oranienbaum text-white/30">{events?.length}</span>
      </div>
      {events?.length === 0 ? (
        <p className="text-[10px] text-white/25 font-oranienbaum px-2">{emptyMsg}</p>
      ) : (
        <div className="space-y-1.5">
          {events?.slice(0, 5)?.map(ev => <EventItem key={ev?.id} ev={ev} />)}
          {events?.length > 5 && (
            <p className="text-[10px] text-white/30 font-oranienbaum text-center py-1">+{events?.length - 5} más</p>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div className="bg-[#1A1A1A] rounded-xl border border-white/8 p-4 h-full">
      <h3 className="text-sm font-oranienbaum font-bold text-[#D6EF4E] mb-4 flex items-center gap-2">
        <Icon name="Layers" size={14} style={{ color: '#D6EF4E' }} />
        Panel de Eventos
      </h3>

      <Section title="Hoy" icon="Sun" iconColor="#D6EF4E" events={eventosHoy} emptyMsg="Sin eventos hoy" />
      <div className="border-t border-white/5 my-3" />
      <Section title="Esta Semana" icon="CalendarDays" iconColor="#3A7F6B" events={eventosSemana} emptyMsg="Sin eventos esta semana" />
      <div className="border-t border-white/5 my-3" />
      <Section title="Pendientes de Confirmar" icon="Clock" iconColor="#C9A24D" events={pendientesConfirmar} emptyMsg="Sin pendientes" />
      <div className="border-t border-white/5 my-3" />
      <Section title="Urgentes" icon="AlertTriangle" iconColor="#ef4444" events={urgentes} emptyMsg="Sin urgentes" />
    </div>
  );
};

export default RightPanel;
